import { createFileRoute } from '@tanstack/react-router';
import ExperienceDetails from '~/containers/Experiences/ExperienceDetails';

export const Route = createFileRoute('/experiences/$experienceId/')({
  component: ExperienceDetails,
});
